import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import cns from '../../../node_modules/classnames/index.js';
import BadgeAlarmIcon from '../../Icons/BadgeAlarmIcon.js';
import BadgeWarningIcon from '../../Icons/BadgeWarningIcon.js';
import BadgeSuccessIcon from '../../Icons/BadgeSuccessIcon.js';
import BadgeInfoIcon from '../../Icons/BadgeInfoIcon.js';
import { InfoState, Position, Emphasis } from '../../types.js';
import '../../GoogleIcons/Outlined/AccountBalanceIcon.js';
import '../../GoogleIcons/Outlined/AccountBoxIcon.js';
import '../../GoogleIcons/Outlined/AddCircleIcon.js';
import '../../GoogleIcons/Outlined/AddIcon.js';
import '../../GoogleIcons/Outlined/ArrowBackIcon.js';
import '../../GoogleIcons/Outlined/ArrowForwardIcon.js';
import '../../GoogleIcons/Outlined/AttachIcon.js';
import '../../GoogleIcons/Outlined/AutoGraphIcon.js';
import '../../GoogleIcons/Outlined/BackupIcon.js';
import '../../GoogleIcons/Outlined/BuildIcon.js';
import '../../GoogleIcons/Outlined/BusinessCenterIcon.js';
import '../../GoogleIcons/Outlined/BusinessIcon.js';
import '../../GoogleIcons/Outlined/CalculateIcon.js';
import '../../GoogleIcons/Outlined/CalendarMonthIcon.js';
import '../../GoogleIcons/Outlined/CalendarTodayIcon.js';
import CancelIcon from '../../GoogleIcons/Outlined/CancelIcon.js';
import '../../GoogleIcons/Outlined/CashIcon.js';
import CheckCircleIcon from '../../GoogleIcons/Outlined/CheckCircleIcon.js';
import '../../GoogleIcons/Outlined/ChecklistIcon.js';
import '../../GoogleIcons/Outlined/CloseFullScreenIcon.js';
import '../../GoogleIcons/Outlined/CloseIcon.js';
import '../../GoogleIcons/Outlined/CloudDoneIcon.js';
import '../../GoogleIcons/Outlined/CompanyChangeIcon.js';
import '../../GoogleIcons/Outlined/CompensazioneIcon.js';
import '../../GoogleIcons/Outlined/ComputerCheckIcon.js';
import '../../GoogleIcons/Outlined/ComputerIcon.js';
import '../../GoogleIcons/Outlined/ContentCopyIcon.js';
import '../../GoogleIcons/Outlined/CreditCardIcon.js';
import '../../GoogleIcons/Outlined/DateRangeIcon.js';
import '../../GoogleIcons/Outlined/DeadlineIcon.js';
import '../../GoogleIcons/Outlined/DeleteIcon.js';
import '../../GoogleIcons/Outlined/DescriptionIcon.js';
import '../../GoogleIcons/Outlined/DesignServiceIcon.js';
import '../../GoogleIcons/Outlined/DocumentReceivedIcon.js';
import '../../GoogleIcons/Outlined/DocumentSendIcon.js';
import '../../GoogleIcons/Outlined/DoneIcon.js';
import '../../GoogleIcons/Outlined/DoneOutlineIcon.js';
import '../../GoogleIcons/Outlined/EditIcon.js';
import '../../GoogleIcons/Outlined/ErrorIcon.js';
import '../../GoogleIcons/Outlined/EuroSymbolIcon.js';
import '../../GoogleIcons/Outlined/EventBusyIcon.js';
import '../../GoogleIcons/Outlined/EventIcon.js';
import '../../GoogleIcons/Outlined/ExcelIcon.js';
import '../../GoogleIcons/Outlined/ExpandLessIcon.js';
import '../../GoogleIcons/Outlined/ExpandMoreIcon.js';
import '../../GoogleIcons/Outlined/ExportExcelIcon.js';
import '../../GoogleIcons/Outlined/ExportIcon.js';
import '../../GoogleIcons/Outlined/FileCopyIcon.js';
import '../../GoogleIcons/Outlined/FileDownloadIcon.js';
import '../../GoogleIcons/Outlined/FileUploadIcon.js';
import '../../GoogleIcons/Outlined/Filter1Icon.js';
import '../../GoogleIcons/Outlined/FontDownloadIcon.js';
import '../../GoogleIcons/Outlined/FormatListBulletedIcon.js';
import '../../GoogleIcons/Outlined/GavelIcon.js';
import '../../GoogleIcons/Outlined/HelpIcon.js';
import '../../GoogleIcons/Outlined/HistoryIcon.js';
import '../../GoogleIcons/Outlined/HomeIcon.js';
import '../../GoogleIcons/Outlined/ImportIcon.js';
import InfoIcon from '../../GoogleIcons/Outlined/InfoIcon.js';
import '../../GoogleIcons/Outlined/InsertDriveIcon.js';
import '../../GoogleIcons/Outlined/InvioTelematicoIcon.js';
import '../../GoogleIcons/Outlined/IOSShareIcon.js';
import '../../GoogleIcons/Outlined/LayersIcon.js';
import '../../GoogleIcons/Outlined/LockIcon.js';
import '../../GoogleIcons/Outlined/LockOpenIcon.js';
import '../../GoogleIcons/Outlined/LogoutIcon.js';
import '../../GoogleIcons/Outlined/LowPriorityIcon.js';
import '../../GoogleIcons/Outlined/MarkunreadIcon.js';
import '../../GoogleIcons/Outlined/MeetingRoom.js';
import '../../GoogleIcons/Outlined/MoreIcon.js';
import '../../GoogleIcons/Outlined/MoreVertIcon.js';
import '../../GoogleIcons/Outlined/NavigateBeforeIcon.js';
import '../../GoogleIcons/Outlined/NavigateNextIcon.js';
import '../../GoogleIcons/Outlined/NoteAddIcon.js';
import '../../GoogleIcons/Outlined/NoteCancelIcon.js';
import '../../GoogleIcons/Outlined/NoteDoneIcon.js';
import '../../GoogleIcons/Outlined/NoteSearchIcon.js';
import '../../GoogleIcons/Outlined/NotificationsIcon.js';
import '../../GoogleIcons/Outlined/OpenInFullIcon.js';
import '../../GoogleIcons/Outlined/OpenInNewIcon.js';
import '../../GoogleIcons/Outlined/PermIdentityIcon.js';
import '../../GoogleIcons/Outlined/PersonUpgradeIcon.js';
import '../../GoogleIcons/Outlined/PollIcon.js';
import '../../GoogleIcons/Outlined/PosponeIcon.js';
import '../../GoogleIcons/Outlined/PrintIcon.js';
import '../../GoogleIcons/Outlined/ProductionQuantityLimitsIcon.js';
import '../../GoogleIcons/Outlined/PriorityHighIcon.js';
import '../../GoogleIcons/Outlined/ReceiptIcon.js';
import '../../GoogleIcons/Outlined/RedoIcon.js';
import '../../GoogleIcons/Outlined/RefreshIcon.js';
import '../../GoogleIcons/Outlined/RemoveIcon.js';
import '../../GoogleIcons/Outlined/SaveIcon.js';
import '../../GoogleIcons/Outlined/ScheduleIcon.js';
import '../../GoogleIcons/Outlined/SearchIcon.js';
import '../../GoogleIcons/Outlined/SendIcon.js';
import '../../GoogleIcons/Outlined/SentimentVeryDissatisfiedIcon.js';
import '../../GoogleIcons/Outlined/SettingsIcon.js';
import '../../GoogleIcons/Outlined/SignatureIcon.js';
import '../../GoogleIcons/Outlined/SubtitlesIcon.js';
import '../../GoogleIcons/Outlined/SyncAltIcon.js';
import '../../GoogleIcons/Outlined/TopListIcon.js';
import '../../GoogleIcons/Outlined/UndoIcon.js';
import '../../GoogleIcons/Outlined/VisibilityIcon.js';
import '../../GoogleIcons/Outlined/VisibilityOffIcon.js';
import '../../GoogleIcons/Outlined/SpaceDashboardIcon.js';
import '../../GoogleIcons/Outlined/SupervisorAccountIcon.js';
import '../../GoogleIcons/Outlined/VpnKeyIcon.js';
import '../../GoogleIcons/Outlined/VerifiedIcon.js';
import '../../GoogleIcons/Outlined/VerifiedUserIcon.js';
import WarningIcon from '../../GoogleIcons/Outlined/WarningIcon.js';
import '../../GoogleIcons/Outlined/WifiOffIcon.js';
import '../../GoogleIcons/Outlined/SellIcon.js';
import '../../GoogleIcons/Outlined/FunctionNsoIcon.js';
import '../../GoogleIcons/Outlined/GoodsServicesIcon.js';
import Switch from '../../../utils/Switch.js';

function Arrow() {
    return (jsx("svg", { className: "v2-mini-panel__arrow", viewBox: "0 0 7.38 7.38", children: jsx("path", { d: "M9.89,11.45a.51.51,0,0,1-.22-.67.54.54,0,0,1,.22-.23l6.39-3.19a.5.5,0,0,1,.72.45v6.38a.5.5,0,0,1-.5.5.54.54,0,0,1-.22,0Z", transform: "translate(-9.62 -7.31)" }) }));
}
function Badge(props) {
    let badge = null;
    new Switch()
        .case({ emphasis: Emphasis.LOW, type: InfoState.success }, () => { badge = jsx(CheckCircleIcon, {}); })
        .case({ emphasis: Emphasis.LOW, type: InfoState.info }, () => { badge = jsx(InfoIcon, {}); })
        .case({ emphasis: Emphasis.LOW, type: InfoState.warning }, () => { badge = jsx(WarningIcon, {}); })
        .case({ emphasis: Emphasis.LOW, type: InfoState.alarm }, () => { badge = jsx(CancelIcon, {}); })
        .case({ emphasis: Switch.ALL, type: InfoState.success }, () => { badge = jsx(BadgeSuccessIcon, {}); })
        .case({ emphasis: Switch.ALL, type: InfoState.info }, () => { badge = jsx(BadgeInfoIcon, {}); })
        .case({ emphasis: Switch.ALL, type: InfoState.warning }, () => { badge = jsx(BadgeWarningIcon, {}); })
        .case({ emphasis: Switch.ALL, type: InfoState.alarm }, () => { badge = jsx(BadgeAlarmIcon, {}); })
        .switch(props);
    return badge;
}
function Message({ message, emphasis }) {
    return (jsxs(Fragment, { children: [emphasis === Emphasis.HIGH && jsx(Arrow, {}), jsx("p", { className: "v2-mini-panel__message", children: message })] }));
}
/**
Veicola un messaggio di potenziale interesse per l'utente.

Vedi [Design System di CGN - Panel](https://zeroheight.com/1b5e94371/p/3507d4-panel/b/47e92f)
*/
function MiniPanel({ className, type = InfoState.info, position = Position.right, emphasis = Emphasis.HIGH, message, }) {
    return (jsxs("div", { className: cns('v2-mini-panel', className, `v2-mini-panel--${type}`, `v2-mini-panel--${position}`, `v2-mini-panel--${emphasis.toLowerCase()}`), children: [jsx(Badge, { type: type, emphasis: emphasis }), jsx(Message, { message: message, type: type, emphasis: emphasis })] }));
}

export { MiniPanel as default };
